import './style.scss';
import { SiteDetails } from './Create/SiteDetails/SiteDetails';
import { DeploymentDetails } from './Create/DeploymentDetails/DeploymentDetails';
import { FinalDetails } from './Create/FinalDetails/FinalDetails';
import { TruRoute } from '../../../TruRoute';
import { Suspense } from 'react';
import { LoadingPage } from '@trufla-technology/trumarket-react-design-system';
import { Switch } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
export const ConfigurationRoutes = () => {
  //to be fixed into the next sprint
  const history = useHistory();
  useEffect(() => {
    const currentUrl = window.location.pathname;
    if (currentUrl === '/admin/configurations/system-configuration/') {
      history.push('/configurations/system-configuration/create');
    }
  });
  return (
    <div className="site-configuration-page">
      <Suspense
        fallback={
          <div className="loader-div">
            <LoadingPage />
          </div>
        }
      >
        <Switch>
          <TruRoute
            permission={['createTeam']}
            path="/configurations/system-configuration/create"
            component={SiteDetails}
          />
          <TruRoute
            permission={['createTeam']}
            path="/configurations/system-configuration/details"
            component={DeploymentDetails}
          />
          <TruRoute
            permission={['createTeam']}
            path="/configurations/system-configuration/finalization"
            component={FinalDetails}
          />
        </Switch>
      </Suspense>
    </div>
  );
};
